import { SET_SETTINGS } from "../ActionTypes";

export const setSettings = data => dispatch =>{
    dispatch({
        type: SET_SETTINGS,
        payload: data
    })
}